import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { IStaffingStandardsTower } from './staffing-standards-Tower-list';
import { HttpHelper } from '../../../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class StaffingStandardsTowerService {

    //need to have this somewhere besides hardcoded in here
    //private _staffingStandardsTowerUrl = `http://localhost:55706/api/systemmanagement/SSTower`;
    private _staffingStandardsTowerUrl = `api/systemmanagement/SSTower`;
 
    constructor(private  httpHelper: HttpHelper) { }

    getSSTower(): Observable<IStaffingStandardsTower> {
         return this.httpHelper.get(`${this._staffingStandardsTowerUrl}`)
             //.map((response: Response) => <IStaffingStandardsTower> response.json())
             //.do(httpHelper => console.log('IStaffingStandardsTower: ' +  JSON.stringify(data)))
             //.catch(this.handleError);
    }

   
    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
                 
         console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/staffing-standards/staffing-standards-tower/staffing-standards-tower.service.ts
 **/